<template>
  <section class="container checkout">
    <!-- Checkout Page top section -->
    <div class="row grid-margin">
      <div class="col-xs-12 col-md-9">
        <v-heading :level="1">Bestellijst</v-heading>
      </div>
      <div class="col-md-3 grid-align-end">
        <v-button md primary iconLeft @click.native.prevent="goToCatalog()">
          <icon :is="'VArrowLeftIcon'"></icon>{{ buttonText }}
        </v-button>
      </div>
    </div>
    <!-- Depot Issue Checkbox section -->
    <div class="row grid-margin" v-if="showDepotIssueBlock">
      <div class="col-md-12">
        <table class="table" v-if="displayDepotIssueCheckbox">
          <thead class="head">
            <tr>
              <th>{{ depotIssueCheckboxDetails.DepotIssueCheckboxTitle }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <v-checkbox-group
                  :label="depotIssueCheckboxDetails.DepotIssueCheckboxText"
                  :inputid="'checkDepotIssue'"
                  :overwriteValue="depotIssueCheckboxChecked"
                  :initvalue="depotIssueCheckboxChecked"
                  @input="depotIssueCheckboxChecked = arguments[0]"
                ></v-checkbox-group>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Products section -->
    <div class="row grid-margin">
      <div class="col-xs-12 col-md-12" id="checkoutProducts">
        <v-checkout-product
          v-for="shoppingCartItem in shoppingCart.items"
          :key="shoppingCartItem.productId"
          :product="shoppingCartItem"
          @update="handleShoppingCartItemUpdate"
          @remove="handleShoppingCartItemRemove"
          @add="handleShoppingCartItemAdd"
          ref="checkoutProduct"
        ></v-checkout-product>
      </div>
    </div>
    <!-- Addresses section -->
    <div class="row grid-margin">
      <div class="col-xs-12" v-if="showAddress">
        <!-- Address section -->
        <div class="checkoutAddress" v-if="!assortmentFeatureEnabled" id="checkoutLevering">
          <table class="table">
            <colgroup>
              <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
            </colgroup>
            <thead class="head">
              <tr>
                <th>Levering</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <legend>Gewenste afleverlocatie</legend>
                  <div class="form-group__radio">
                    <input id="homeAddress" name="deliveryaddress" type="radio" checked @change="checkRadioAddress" />
                    <label for="homeAddress"
                      ><span><span></span></span>Woonadres</label
                    >
                  </div>
                  <div class="form-group__radio" v-if="deliveryAddress && deliveryAddress.AdresId !== 0">
                    <input id="deliveryAddress" name="deliveryaddress" type="radio" @change="checkRadioAddress" />
                    <label for="deliveryAddress"
                      ><span><span></span></span>Afwijkend afleveradres</label
                    >
                  </div>
                  <div class="form-group__radio">
                    <input id="differentAddress" name="deliveryaddress" type="radio" @change="checkRadioAddress" />
                    <label for="differentAddress"
                      ><span><span></span></span>Eenmalig afwijkend adres</label
                    >
                  </div>
                </td>
                <td>
                  <legend>Afleveradres</legend>
                  <div v-if="SelectedAddress === 0">
                    {{ homeAddress.Straatnaam }} {{ homeAddress.Huisnummer }}
                    {{ homeAddress.Toevoeging }}
                    <br />
                    {{ homeAddress.Postcode }} {{ homeAddress.Woonplaats }}
                    <br />
                    {{ homeAddress.Land }}
                  </div>
                  <div v-if="SelectedAddress === 1 && deliveryAddress && deliveryAddress.AdresId !== 0">
                    {{ deliveryAddress.Straatnaam }}
                    {{ deliveryAddress.Huisnummer }}
                    {{ deliveryAddress.Toevoeging }}
                    <br />
                    {{ deliveryAddress.Postcode }}
                    {{ deliveryAddress.Woonplaats }}
                    <br />
                    {{ deliveryAddress.Land }}
                  </div>
                  <div v-if="SelectedAddress === 2">
                    <div class="row">
                      <div class="col-xs-12">
                        <v-input-group-simple-2
                          type="text"
                          maxlength="7"
                          v-model="differentAddress.PostCode"
                          @blur="autoFillAddress()"
                          :rules="{
                            required: true,
                            regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                          }"
                          label="Postcode*"
                          id="Postcode"
                        >
                        </v-input-group-simple-2>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <v-input-group-simple-2
                          type="text"
                          v-model="differentAddress.Huisnummer"
                          @blur="autoFillAddress()"
                          :rules="{
                            required: true
                          }"
                          label="Huisnummer*"
                          id="Huisnummer"
                        >
                        </v-input-group-simple-2>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <v-input-group-simple-2
                          type="text"
                          v-model="differentAddress.Toevoeging"
                          :rules="{
                            required: false
                          }"
                          label="Toevoeging"
                          id="Toevoeging"
                        >
                        </v-input-group-simple-2>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <v-input-group-simple-2
                          :key="prefillAddressDataKey"
                          type="text"
                          v-model="differentAddress.Straatnaam"
                          :rules="{
                            required: true
                          }"
                          label="Straatnaam*"
                          id="Straatnaam"
                          :disabled="addressLookupSuccessful"
                        >
                        </v-input-group-simple-2>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <v-input-group-simple-2
                          :key="prefillAddressDataKey"
                          type="text"
                          v-model="differentAddress.Woonplaats"
                          :rules="{
                            required: true
                          }"
                          label="Woonplaats*"
                          id="Woonplaats"
                          :disabled="addressLookupSuccessful"
                        >
                        </v-input-group-simple-2>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div v-if="showNeighborsDeliveryAllowed">
                    <legend>Afleveren bij de buren</legend>
                    <span class="checkoutProduct__extraOptions__checkbox">
                      <v-checkbox-group
                        label="Niemand thuis? Geef dan hier
                                      toestemming om het pakket bij de buren te leveren"
                        :inputid="'NeighborsDeliveryAllowed'"
                        :overwriteValue="NeighborsDeliveryAllowed"
                        @input="changeNeighborsDeliveryAllowed('NeighborsDeliveryAllowed', ...arguments)"
                        :initvalue="NeighborsDeliveryAllowed"
                      ></v-checkbox-group>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row grid-margin checkout__otherOptions">
      <div class="col-md-12">
        <!-- Service section -->
        <table class="table" v-if="!assortmentFeatureEnabled && kwartaalService">
          <colgroup>
            <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
          </colgroup>
          <thead class="head">
            <tr>
              <th>{{ kwartaalServiceDetails.Title }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ kwartaalServiceDetails.Information }}
              </td>
            </tr>
            <tr class="serviceBackground">
              <td>
                <v-checkbox-group inputid="repeatService" @input="changeRepeatService(...arguments)">{{
                  kwartaalServiceDetails.Description
                }}</v-checkbox-group>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Order Number section -->
        <table class="table" v-if="assortmentFeatureEnabled">
          <colgroup>
            <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
          </colgroup>
          <thead class="head">
            <tr>
              <th>Ordernummer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-xs-12">
                    <v-input-group-simple-2
                      maxlength="128"
                      v-model="orderNumberModel"
                      :rules="{
                        required: false,
                        regex: [/^[a-zA-Z0-9]*$/i]
                      }"
                      id="Ordernummer"
                      placeholder="Vul hier uw ordernummer of betalingskenmerk in."
                      class="orderNummer"
                      type="text"
                    >
                    </v-input-group-simple-2>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Kies uw gewenste bezorgmoment section -->
        <table id="deliveryTimings" class="table" v-if="deliveryDateFeature && possibleDeliveryDates.length > 0">
          <colgroup>
            <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
          </colgroup>
          <thead class="head">
            <tr>
              <th>Kies uw gewenste bezorgmoment</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-xs-12 checkout__deliveryDates">
                    <v-select-group
                      selectid="PossibleDeliveryDates"
                      :initselected="possibleDeliveryDates[0].Key"
                      :overwriteValue="possibleDeliveryDates[0].Key"
                      @change="setSelectedDeliveryDate($event)"
                    >
                      <option
                        v-for="(item, index) in possibleDeliveryDates"
                        :key="index"
                        :data-index="index"
                        :value="item.Key"
                      >
                        {{ item.Value }}
                      </option>
                    </v-select-group>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="timeWindow" v-if="showTimeWindowCheck">
              <td>
                <v-checkbox-group
                  label="Eerst mogelijke bezorgmoment op deze dag"
                  v-model="isTimeWindowDelivery"
                  :overwriteValue="isTimeWindowDelivery"
                  inputid="timeWindow"
                ></v-checkbox-group>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- careprogram section -->
        <v-table
          :class="{ disableCareProgram: !customerMarketingPermission }"
          v-for="(careProgram, careProgramKey) in careProgramDetails"
          :key="careProgramKey"
        >
          <v-care-programme-row
            :data="careProgram"
            :index="careProgramKey"
            @careProgramAction="careProgramAction"
          ></v-care-programme-row>
        </v-table>
        <!-- FAQs Section -->
        <table class="table" v-if="!assortmentFeatureEnabled">
          <colgroup>
            <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
          </colgroup>
          <thead class="head">
            <tr>
              <th>Veelgestelde vragen</th>
            </tr>
          </thead>
          <tbody>
            <v-faq-row
              v-for="(faq, index) in faqsByCustomFilter"
              :faq="faq"
              :key="index"
              :index="index"
              :totalFaq="faqsByCustomFilter.length"
            >
            </v-faq-row>
          </tbody>
          <!--Show More/Less Functionality -->
          <div class="row grid-justify-content-center" v-if="faqs && faqs.length > filterCountDefault">
            <v-button hollow md class="filter-count-button" @click.native="toggleFilterCount">
              <template v-if="!filterCount">{{ filterCountButtonTextOptions.less }}</template>
              <template v-if="filterCount > 0"
                >{{ filterCountButtonTextOptions.more }}&nbsp;
                <span v-if="faqs.length > filterCountDefault">({{ faqs.length }})</span>
              </template>
            </v-button>
          </div>
        </table>
        <!-- Remarks section -->
        <table class="table">
          <colgroup>
            <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
          </colgroup>
          <thead class="head">
            <tr>
              <th>Opmerkingen (optioneel)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <textarea
                  class="checkout__textarea"
                  id="checkout-remarks"
                  placeholder="Opmerkingen"
                  @input="setRemarks($event.target.value)"
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row grid-margin" id="checkoutOrder">
      <div class="col-xs-8">
        <a class="back-to-catalog" @click="goToCatalog"
          ><v-arrow-left-icon></v-arrow-left-icon>
          <div class="backText">{{ buttonText }}</div></a
        >
      </div>
      <div class="col-xs-4">
        <v-button md cta class="save-checkout" @click.native.prevent="saveCheckout">Bestelling versturen</v-button>
      </div>
    </div>
    <!-- Modals section -->
    <generic-modal v-if="noProductOverlay">
      <template #header> Let op! </template>
      <template #body>
        <p>{{ popupMessage }}</p>
      </template>
      <template #footer>
        <v-button md hollow transparent @click.native="closeModal">Annuleren</v-button>
        <v-button md primary @click.native="goToCatalog()">Bevestigen</v-button>
      </template>
    </generic-modal>
  </section>
</template>

<script>
import 'intro.js/minified/introjs.min.css';
import introJs from 'intro.js';
import { mapGetters } from 'vuex';
import store from '@/store';
import router from '@/router';
import VArrowLeftIcon from 'icons/ArrowLeft';
import VCheckoutProduct from './CheckoutProduct';
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup';
import VFaqRow from './FaqRow';
import VTable from '@/components/shared/table/Table';
import VCareProgrammeRow from '@/components/sections/patient/CareProgrammeRow';
import VStarCircleIcon from 'icons/StarCircle';
import GenericModal from '@/components/shared/GenericModal';
import {
  removeFromShoppingCart,
  activeCustomerId$,
  shoppingCart$,
  addToShoppingCart,
  clearShoppingCart,
  updateShoppingCartItem,
  currentUserIdentity$,
  activePpwRecId$,
  assortmentFeatureEnabled$,
  checkout,
  checkoutSuccessful$
} from '@/services';
import { BehaviorSubject } from 'rxjs';
import { tap, filter, map, distinctUntilChanged, switchMap } from 'rxjs/operators';

export default {
  name: 'Checkout',
  components: {
    VArrowLeftIcon,
    VCheckoutProduct,
    VCheckboxGroup,
    VFaqRow,
    VStarCircleIcon,
    VTable,
    VCareProgrammeRow,
    GenericModal
  },
  subscriptions() {
    return {
      shoppingCart: shoppingCart$,
      shoppingCartChanged: shoppingCart$.pipe(
        map((m) => (m ? m.items.length : 0)),
        distinctUntilChanged(),
        filter((m) => m > 0),
        tap(this.displayDemo)
      ),
      assortmentFeatureEnabled: assortmentFeatureEnabled$,
      activeCustomerId: assortmentFeatureEnabled$.pipe(
        switchMap((enabled) => {
          return enabled ? new BehaviorSubject(null) : activeCustomerId$;
        })
      ),
      prescriberDetails: currentUserIdentity$,
      activePpwRecId: activePpwRecId$,
      orderIdsCreated: checkoutSuccessful$.pipe(
        tap((e) => {
          router.push({
            path: '/orderconfirmation',
            query: {
              orderId: e.data.orderIds
            }
          });
          return null;
        })
      )
    };
  },
  data() {
    return {
      validator: this.$validator,
      orderNumberModel: '',
      isTimeWindowDelivery: false,
      addressLookup: null,
      filterCountDefault: 5,
      filterCount: null,
      filterCountButtonTextOptions: {
        more: 'Toon meer',
        less: 'Toon minder'
      },
      // ShowNeighborsDeliveryAllowed: true,
      noProductOverlay: false,
      intro: introJs(),
      currentRoute: '',
      submitOrderPopupMessage: '',
      prefillAddressDataKey: 0,
      checkDepotIssue: false
    };
  },
  computed: {
    // VueJs store map getters to fetch store data
    ...mapGetters({
      homeAddress: 'cart/getCheckoutHomeAddress',
      deliveryAddress: 'cart/getCheckoutDeliveryAddress',
      differentAddress: 'cart/getCheckoutDifferentAddress',
      patientDetails: 'patient/getPatientGegevens',
      siteCode: 'navigation/getSiteCode',
      SelectedAddress: 'cart/getSelectedAddress',
      orderNumber: 'cart/getOrderNumber',
      kwartaalService: 'cart/getKwartaalServiceStatus',
      kwartaalServiceDetails: 'cart/getKwartaalServiceDetails',
      faqs: 'cart/getFaqs',
      remarks: 'cart/getRemarks',
      NeighborsDeliveryAllowed: 'cart/getNeighborsDeliveryAllowed',
      userMarketingPermission: 'navigation/getUserMarketingPermission',
      careProgramDetails: 'patient/getCareProgramDetails',
      buttonText: 'cart/getButtonText',
      possibleDeliveryDates: 'cart/getPossibleDeliveryDates',
      depotIssueCheckboxDetails: 'cart/getDepotIssueCheckboxDetails',
      userWarehouseStatus: 'cart/getUserWarehouseStatus'
    }),
    addressLookupSuccessful() {
      return this.addressLookup !== null;
    },
    /**
     * @returns {array} - list with faqs filtered by dynamic value of count and sliced by dynamic value of filtercount
     */
    faqsByCustomFilter() {
      const computedFaqs = this.faqs;
      if (computedFaqs && computedFaqs.length > 0) {
        // Slice the faqs by the filter count if active else return all
        return this.filterCount ? computedFaqs.slice(0, this.filterCount) : computedFaqs;
      } else {
        return [];
      }
    },
    /**
     * @returns {boolean} - true when any shopping cart product is not given to the patient
     * */
    requireDelivery() {
      var itemsNotGivenToPatient = this.shoppingCart.items.filter((item) => item.givenToPatient !== true);
      return itemsNotGivenToPatient.length > 0;
    },
    deliveryDateFeature() {
      return this.shoppingCart.items.filter((item) => item.givenToPatient !== true).length > 0;
    },
    showNeighborsDeliveryAllowed() {
      return this.requireDelivery;
    },
    showAddress() {
      return this.requireDelivery;
    },
    isDemo() {
      return (
        store.state.navigation.demo &&
        store.state.navigation.demoActivated &&
        store.state.navigation.demoFlow.catalogFlow
      );
    },
    showTimeWindowCheck() {
      return this.shoppingCart.items.findIndex((item) => item.treatmentAreaId === '1006') == -1 &&
        store.state.cart.selectedDeliveryDate === this.possibleDeliveryDates[0].Key
        ? true
        : false;
    },
    displayDepotIssueCheckbox() {
      for (let i = 0; i < this.shoppingCart.items.length; i++) {
        var itemRef = this.shoppingCart.items[i];
        if (itemRef.supportGivenToPatient) {
          return true;
        }
      }
      return false;
    },
    depotIssueCheckboxChecked: {
      get: function () {
        for (let i = 0; i < this.shoppingCart.items.length; i++) {
          var itemRef = this.shoppingCart.items[i];
          if (!itemRef.supportGivenToPatient) {
            continue;
          }

          if (!itemRef.givenToPatient || !itemRef.fillUpStock) {
            return false;
          }
        }
        return true;
      },
      set: function (value) {
        for (let i = 0; i < this.shoppingCart.items.length; i++) {
          var itemRef = this.shoppingCart.items[i];
          if (itemRef.supportGivenToPatient && itemRef.givenToPatient != value) {
            itemRef.givenToPatient = value;

            if (itemRef.supportFillUpStock) {
              itemRef.fillUpStock = value;
            }

            this.handleShoppingCartItemUpdate(itemRef);
          }
        }
      }
    },
    orderNumberAdded() {
      return this.orderNumberModel.length;
    },
    customerMarketingPermission() {
      let status = false;
      if (this.userMarketingPermission !== null) {
        for (let key in this.userMarketingPermission) {
          if (this.userMarketingPermission[key]) {
            status = true;
            break;
          }
        }
      }
      return status;
    },
    showDepotIssueBlock () {
      return this.userWarehouseStatus
        && this.depotIssueCheckboxDetails
        && this.depotIssueCheckboxDetails.ShowDepotIssueCheckbox
        && !this.assortmentFeatureEnabled
    },
    /**
     * @function isInfuusPortal - function to check whether to portal is infuus or not
     */
    isInfuusPortal() {
      return store.state.navigation.siteCode === 'MIF';
    }
  },
  created() {
    // Get 6 possible consecutive delivery dates
    store.dispatch('cart/fetchPossibleDeliveryDates');
    // Dispatching server calls to fetch Prescriber, Patient details
    // and using those details to fetch checkout page required details
    store.dispatch('navigation/fetchResults').then(() => {
      if (!this.assortmentFeatureEnabled) {
        store.dispatch('patient/getCurrentPatient').then((response) => {
          this.patientId = this.patientDetails.PatientId;
          this.fetchCheckoutDetails();
        });
      } else {
        this.fetchCheckoutDetails();
      }
    });
    this.filterCount = this.filterCountDefault;
    this.currentRoute = router.currentRoute.name;
  },
  methods: {
    displayDemo(value) {
      if (value > 0 && this.isDemo) {
        setTimeout(() => {
          const self = this;
          this.intro.setOptions({
            steps: [
              {
                element: '#checkoutProducts',
                intro:
                  'Zo, we zijn bijna klaar. Op de checkout pagina krijg je een complete overzicht van je bestelling voor de patient. <br/> <br/> Per product kan je zien wat de levertijd is en of dat het product wel of niet wordt vergoed. <br/> <br/> Daarnaast kan je ook het aantal aanpassen en aangeven of dat het product al is meegegeven aan de patient en of dat we de voorraad op jullie locatie moeten aanvullen. Als je klaar bent druk op volgende om door te gaan.',
                position: 'right'
              },
              {
                element: '#checkoutLevering',
                intro:
                  'Onder het kopje levering kan je aangeven waar de bestelling geleverd moet worden. Daarnaast ook of dat het pakket eventueel ook bij de buren mag worden afgeleverd. Klik op volgende om door te gaan.',
                position: 'right'
              },
              {
                element: '#deliveryTimings',
                intro:
                  'Bij Mediq weten we dat het niet altijd uitkomt dat een patient een bestelling kan ontvangen. Daarom kan er wanneer gewenst ook iets later voor een aflevermoment worden gekozen. Klik op volgende om door te gaan.',
                position: 'right'
              },
              {
                element: '#checkoutOrder',
                intro:
                  'Als je helemaal klaar bent met de bestelling dan druk je op de knop "Bestelling versturen". De bestelling wordt direct doorgezet en wordt zo snel mogelijk verwerkt door Mediq.',
                position: 'top'
              }
            ],
            exitOnEsc: false,
            exitOnOverlayClick: false,
            skipLabel: 'Overslaan',
            nextLabel: 'Volgende >',
            prevLabel: '< Terug',
            doneLabel: 'Okey, begrepen'
          });
          this.intro.start().oncomplete(function () {
            self.intro.exit();
            store.commit('navigation/setDemoFlowStatus', {
              key: 'checkoutFlow',
              value: false
            });
          });
          window.scrollTo(0, 0);
        }, 1500);
      }
    },
    closeModal() {
      this.noProductOverlay = false;
    },
    /**
     * @function fetchCheckoutDetails - Function to fetch checkout page details
     */
    fetchCheckoutDetails() {
      let requiredIds = {
        prescriberId: this.prescriberDetails.id,
        patientId: this.activeCustomerId
      };
      store.dispatch('cart/fetchCheckoutDetails', requiredIds).then((response) => {
        this.popupMessage = response.DeleteProductPopupMessage;
        this.noProductOverlay = false;
        /*
          // Original code: it is showing the wrong popup. Once fixed we can put the code back in although needs to be based on observable, not on promise.
          response.DeleteProductPopupMessage &&
          (!this.shoppingCart || (this.shoppingCart.items && this.shoppingCart.items.length === 0));
        */
        this.submitOrderPopupMessage = response.SubmitOrderPopupMessage;
      });
    },
    handleShoppingCartItemUpdate(item) {
      updateShoppingCartItem(this.shoppingCart, item, this.activePpwRecId);
    },
    handleShoppingCartItemRemove(item) {
      // We want the UI to be fast and not wait for debounced stuff.
      const index = this.shoppingCart.items.indexOf(item);
      if (index >= 0) {
        this.shoppingCart.items.splice(index, 1);
      }

      removeFromShoppingCart(this.shoppingCart, item.cartId);
    },
    handleShoppingCartItemAdd(item) {
      addToShoppingCart(this.shoppingCart, item.productId, item.count, this.activePpwRecId);
    },
    handleClearShoppingCart() {
      clearShoppingCart(this.shoppingCart).then(() => {
        this.closeModal();
      });
    },
    internalSaveCheckout(customerId) {
      let command = {
        customerId: customerId,
        deliveryDate: store.state.cart.selectedDeliveryDate,
        remark: store.state.cart.checkoutDetails.Remarks,
        orderNumber: store.state.cart.checkoutDetails.orderNumber,
        isRepeating: store.state.cart.checkoutDetails.RepeatService,
        NeighborsDeliveryAllowed: store.state.cart.checkoutDetails.NeighborsDeliveryAllowed,
        addressType: store.state.cart.checkoutDetails.SelectedAddress,
        CustomerMarketingPermission: null,
        address: null
      };
      if (store.state.cart.checkoutDetails.SelectedAddress === 0) {
        command.address = store.state.cart.checkoutDetails.HomeAddress;
      }
      if (store.state.cart.checkoutDetails.SelectedAddress === 1) {
        command.address = store.state.cart.checkoutDetails.DeliveryAddress;
      }
      if (store.state.cart.checkoutDetails.SelectedAddress === 2) {
        command.address = store.state.cart.checkoutDetails.DifferentAddress;
      }
      Object.keys(command.address).forEach((key) => {
        let newKey = key.toLowerCase();
        command.address[newKey] = command.address[key];
        delete command.address[key];
      });
      if (store.state.patient.customerMarketingPermission) {
        command.CustomerMarketingPermission = store.state.patient.customerMarketingPermission;
      } else {
        command.CustomerMarketingPermission = store.state.patient.patientGegevens.CustomerMarketingPermission;
      }
      // isTimeWindowDelivery value
      command.isTimeWindowDelivery = this.isTimeWindowDelivery;

      return checkout(command);
    },
    // Function to create order and send details to the server
    saveCheckout() {
      this.$validateAllComponents().then((result) => {
        if (result === false) {
          // Form is invalid. Exiting.
          return;
        }

        if (this.SelectedAddress === 2 || this.assortmentFeatureEnabled) {
          // Only difference in original code was that `validateFields` set the country - looks lke we can assume it is always NL.
          this.differentAddress.Land = 'NL';
        }

        if (this.assortmentFeatureEnabled) {
          store.commit('cart/setOrderNumber', this.orderNumberModel);
        }
        this.internalSaveCheckout(this.shoppingCart.customerId);
      });
    },
    // Function to update address details based on the user address radio option selection
    checkRadioAddress(e) {
      let checkedAddress = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id;
      if (checkedAddress === 'homeAddress') {
        store.commit('cart/setSelectedAddress', 0);
      }
      if (checkedAddress === 'deliveryAddress') {
        store.commit('cart/setSelectedAddress', 1);
      }
      if (checkedAddress === 'differentAddress') {
        store.commit('cart/setSelectedAddress', 2);
      }
    },
    /**
     * @function changeRepeatService -  Function to set repeat service true or false based on user interaction
     * @param {boolean} - active
     */
    changeRepeatService(active) {
      store.commit('cart/setRepeatService', active);
    },
    changeNeighborsDeliveryAllowed(key, active) {
      store.commit('cart/setNeighborsDeliveryAllowed', active);
    },
    /**
     * @function setRemarks - Function to set remarks based on user interaction
     * @param {string} - remarks
     */
    setRemarks(remarks) {
      store.commit('cart/setRemarks', remarks);
    },
    /**
     * @function autoFillAddress - Function to auto fill the address
     */
    autoFillAddress() {
      store
        .dispatch('patient/fetchAddressLookup', {
          postcode: this.differentAddress.PostCode,
          huisnummer: this.differentAddress.Huisnummer,
          land: 'NL'
        })
        .then((response) => {
          var hasAddress = response.data.City !== null;

          this.differentAddress.Straatnaam = hasAddress ? response.data.Street : '';
          this.differentAddress.Woonplaats = hasAddress ? response.data.City : '';

          this.addressLookup = hasAddress ? response.data : null;
          this.$validator.validateAll();
          this.prefillAddressDataKey += 1;
        })
        .catch(() => {
          this.addressLookup = null;
          this.differentAddress.Straatnaam = '';
          this.differentAddress.Woonplaats = '';
        });
    },
    /**
     * @function goToCatalog - Function to rediect to catalog page
     */
    goToCatalog() {
      this.noProductOverlay = false;
      if (router.currentRoute.name !== 'aanvullenmagazijnCheckout') {
        router.push('/catalog');
      } else {
        this.patientId = null;
        router.push('/aanvullenmagazijn');
      }
    },
    /**
     * @function toggleFilterCount
     * @desc Toggles the filter count between null and filterCountDefault
     */
    toggleFilterCount() {
      this.filterCount = this.filterCount ? null : this.filterCountDefault;
    },
    setSelectedDeliveryDate(e) {
      store.state.cart.selectedDeliveryDate = e.currentTarget.value;
      if (e.currentTarget.value !== this.possibleDeliveryDates[0].key) {
        this.isTimeWindowDelivery = false;
      }
    },
    careProgramAction(actionDetails) {
      store.commit('patient/setCustomerMarketingPermissionSubOption', actionDetails);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout {
  color: $gray-darkest;
  .heading {
    margin: 0px;
  }
  .filter-count-button {
    margin: 20px;
  }
  .serviceBackground,
  .timeWindow {
    background-color: $light-blue-gray;
  }
  &__textarea {
    border-radius: 4px;
    border: 1px solid $gray;
    width: 100%;
    padding: 10px;
    color: $gray-darkest;
    &:focus-visible {
      outline: $gray;
    }
  }
  &__otherOptions {
    table {
      margin-bottom: 24px;
    }
  }
  .back-to-catalog {
    cursor: pointer;
  }
  .backText {
    margin: 4px 24px;
    text-decoration: underline;
  }
  .material-design-icon {
    fill: $black;
    float: left;
  }
  // Width of each table column
  $table-columns: (
    1: 40px,
    2: 30%,
    3: 30%,
    4: 15%,
    5: 15%,
    6: 50px
  ) !default;
  table {
    background-color: $grayish-very-light;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    table-layout: auto !important;
    width: 100%;
    border-collapse: collapse;
    // Generate classes for each column and assign width
    @each $table-column-key, $table-column-value in $table-columns {
      .table-col-#{$table-column-key} {
        width: $table-column-value;
      }
    }
    > thead > tr {
      background-color: $grayish-very-light;
      height: 54px;
      margin-bottom: 20px;

      > td,
      > th {
        font-size: 16px;
        color: $grayish-very-dark;
        font-weight: 400;
        padding: 20px;
        float: left;
      }
    }
    > tbody {
      background: $white;
      legend {
        margin: 0 0 20px;
      }

      > tr:first-child {
        > td,
        > th {
          vertical-align: baseline;
          text-align: left;
          padding: 16px 16px;
          width: 33%;
          max-width: 300px;
        }
      }

      > tr:last-child td {
        padding: 16px 16px;
      }

      &.action-required {
        background-color: $pink;
      }
    }
    .hidden {
      display: none;
    }
  }
  .checkoutAddress {
    table {
      > tbody {
        background: $white;
        legend {
          font-size: 16px;
          font-weight: bold;
        }

        > tr:first-child {
          > td,
          > th {
            vertical-align: baseline;
            text-align: left;
            padding: 16px 20px;
          }
        }

        > tr:last-child td {
          padding: 10px 20px 16px;
        }
      }
    }
  }
  .save-checkout {
    z-index: 99;
    position: fixed;
    top: 90%;
    right: 8%;
  }
  .disableCareProgram {
    display: none;
  }
  /deep/ .checkbox-group {
    &__label {
      &__inner {
        color: $gray-darkest;
      }
    }
  }
  /deep/ .asterisk {
    display: none;
  }
  /deep/ .careProgramme-row {
    background: rgba(0, 0, 0, 0.03) !important;
  }
  /deep/ .form-group {
    padding: 0px;
    input {
      border-style: none;
      border: 1px solid $gray-darkest;
      border-radius: 5px;
      padding: 10px 0px 10px 15px;
      color: $gray-darkest;
      height: auto;
    }
    label {
      position: absolute;
      top: -20px;
      left: 10px;
      background: $white;
      width: auto;
      padding: 5px;
      font-size: 12px;
      color: $gray-darkest;
    }
    &--focused {
      label {
        font-size: 12px;
        color: $gray-darkest;
        transform: none;
        width: auto;
        max-width: 100%;
      }
    }
    &--hasvalue {
      label {
        font-size: 12px;
        color: $gray-darkest;
        transform: none;
        width: auto;
        max-width: 100%;
      }
    }
    &__details {
      min-height: 0 !important;
      &:before {
        content: none;
      }
      &:after {
        content: none;
      }
      .form-group {
        &__error {
          padding-bottom: 8px;
        }
      }
    }
    &__icon {
      margin: -5px 10px 0px 0px;
    }
  }
  &__deliveryDates {
    /deep/ .form-group {
      select {
        margin: 0px;
      }
      label {
        padding-left: 10px;
        margin-top: -8px;
      }
      &--hasvalue {
        label {
          display: none;
        }
      }
    }
  }
}
</style>
